import { CountryID } from "@al/base-lib";

/**
 * 兜底国家配置
 */
export const defaultCountryAddress: Partial<Record<CountryID, { provinceId: number; provinceName: string }>> = {
  [CountryID.DE]: { provinceId: 170003, provinceName: "Berlin" },
  [CountryID.BE]: { provinceId: 170865, provinceName: "Bruxelles (19 communes)" },
  [CountryID.ES]: { provinceId: 160010, provinceName: "Comunidad de Madrid" },
  [CountryID.PL]: { provinceId: 170898, provinceName: "Mazowieckie" },
  [CountryID.FR]: { provinceId: 170493, provinceName: "Paris" },
  [CountryID.IT]: { provinceId: 170703, provinceName: "Roma" },
};
